import { Rate } from 'antd';
import styled from 'styled-components';

export default styled(Rate)`
	// Add your styles here
`;
